export enum SortType {
  ASC = "ASC",
  DESC = "DESC",
}

export const SortTypeList = [
  { value: "ASC", id: 1 },
  { value: "DESC", id: 2 },
];
